import { Skeleton } from "@/components/skeleton";

export function OverviewSkeleton() {
  return (
    <div className="p-xl flex flex-col gap-3xl">
      <div className="grid grid-cols-1 gap-lg md:grid-cols-3">
        <CurrentPlanCardSkeleton />
        <PaymentMethodsCardSkeleton />
        <UpcomingPaymentCardSkeleton />
      </div>
      <RecentInvoicesSectionSkeleton />
    </div>
  );
}

function CardSkeletonShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="inline-flex flex-col justify-between gap-md rounded-xl border border-border-secondary bg-bg-primary py-xl px-3xl">
      {children}
    </div>
  );
}

function IconSkeleton() {
  return <Skeleton className="h-10 w-10 shrink-0 rounded-md" />;
}

function CurrentPlanCardSkeleton() {
  return (
    <CardSkeletonShell>
      <div className="flex items-start justify-between gap-xl">
        <div className="flex flex-col gap-xs">
          <div className="flex h-[18px] items-center">
            <Skeleton className="h-3 w-20" />
          </div>
          <div className="flex h-[30px] items-center">
            <Skeleton className="h-5 w-48" />
          </div>
        </div>
        <IconSkeleton />
      </div>
      <div className="flex flex-wrap gap-md">
        {["w-24", "w-24"].map((width, i) => (
          <Skeleton className={`h-[22px] rounded-sm ${width}`} key={i} />
        ))}
      </div>
    </CardSkeletonShell>
  );
}

function PaymentMethodsCardSkeleton() {
  return (
    <CardSkeletonShell>
      <div className="flex items-start justify-between">
        <div className="flex h-[30px] items-center">
          <Skeleton className="h-5 w-40" />
        </div>
        <IconSkeleton />
      </div>
      <div className="flex items-center gap-md">
        <span className="flex items-center gap-md p-lg">
          <Skeleton className="h-10 w-14.5 rounded-md" />
          <Skeleton className="h-3.5 w-14" />
        </span>
      </div>
    </CardSkeletonShell>
  );
}

function UpcomingPaymentCardSkeleton() {
  return (
    <CardSkeletonShell>
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-xs">
          <div className="flex h-5 items-center">
            <Skeleton className="h-3.5 w-32" />
          </div>
          <div className="flex h-11 items-center">
            <Skeleton className="h-8 w-44" />
          </div>
        </div>
        <IconSkeleton />
      </div>
      <div className="mt-xl flex flex-col gap-xs">
        <div className="flex h-5 items-center">
          <Skeleton className="h-3.5 w-16" />
        </div>
        <div className="flex h-5 items-center">
          <Skeleton className="h-3.5 w-44" />
        </div>
      </div>
    </CardSkeletonShell>
  );
}

function RecentInvoicesSectionSkeleton() {
  return (
    <div>
      <div className="mb-lg flex items-center justify-between">
        <div className="flex h-7 items-center">
          <Skeleton className="h-4.5 w-36" />
        </div>
        <Skeleton className="h-3.5 w-28" />
      </div>
      <div className="flex flex-col divide-y divide-border-secondary">
        {Array.from({ length: 3 }).map((_, i) => (
          <div className="flex items-center gap-xl py-xl" key={i}>
            <div className="flex flex-1 items-center gap-lg">
              <Skeleton className="h-9 w-9 shrink-0 rounded-md" />
              <Skeleton className="h-4.5 w-32" />
            </div>
            <Skeleton className="hidden h-3.5 w-64 lg:block" />
            <Skeleton className="hidden h-3.5 w-56 md:block" />
            <Skeleton className="h-3.5 w-20" />
            <Skeleton className="h-[22px] w-11 rounded-full" />
            <Skeleton className="h-5 w-5 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
